/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-10-25
 * @brief EHPworkorder - EhealthCheck 개발
 *
 ********************************************************************/
import React, { useState } from "react";
import clog from "../../../../utils/logUtils";
//component
import EhealthCheckTree from "./EhealthCheckTree";
import EhealthCheckCRUD from "./EhelthCheckCRUD";
/**
 * @brief EHP WorkOrder - EhealthCheck 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function EhealthCheckMain(props) {
    //
    const [isMobile, setIsMobile] = useState(false);
    const [adminType, setAdminType] = useState("EHC"); // EHC, INSPECTION, HISTORY, CHANGE
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH, SET
    const [workMode, setWorkMode] = useState("LIST");
    const [isTreeOpen, setIsTreeOpen] = useState(true);
    const defaultTree = {
        company: { companyId: "", companyName: "" },
        zone: { zoneId: "", zoneName: "" },
        subZone: { subZoneId: "", subZoneName: "" },
        reload: false
    };
    const [selTree, setSelTree] = useState(defaultTree);
    function handleSelTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setAdminType(adminType);
        setSelTree(treeInfo);
    }
    clog("IN EHC MAIN : " + adminType + " : " + workMode);
    return (React.createElement(React.Fragment, null,
        React.createElement(EhealthCheckTree, { isTreeOpen: isTreeOpen, setIsTreeOpen: setIsTreeOpen, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, adminType: adminType, setAdminType: setAdminType }),
        (adminType === "EHC") && React.createElement(EhealthCheckCRUD, { isTreeOpen: isTreeOpen, isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setNodata: props.setNodata, setPopWin: props.setPopWin })));
}
export default EhealthCheckMain;
